
export function parsePrice(val){
    if (!val) {
        val = 0;
    }
    if(typeof(val) == 'string'){
        val = Number(val)
    }
    return val.toFixed(2).split(".");
}